import React from 'react';
import PropTypes from 'prop-types';

import {Title, Box} from 'views/components';

const ClientNameView = (props) => {
  const {
    clientData,
    setIsEditing,
  } = props;

  const clientName = clientData.clientName;

  return (
    <Box
      sx={{
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    >
      <Title disableDivider sx={{my: '8px', fontWeight: 'bold'}}>
        {clientName}
      </Title>
    </Box>
  );
};

ClientNameView.propTypes = {
  clientData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientNameView);
